import { useState } from "react";
import { NavLink } from "react-router-dom";
import "./sidebar.css";
import {
  Logo,
  DashboardIcon,
  DashboardIconActive,
  OrganizationIcon,
  OrganizationIconActive,
  CustomerIcon,
  CustomerIconActive,
  ProgramManagerIcon,
  ProgramManagerIconActive,
  VendorIcon,
  VendorIconActive,
  ServiceIcon,
  ServiceIconActive,
  BusinessUserIcon,
  BusinessUserIconActive,
  ExpenseIcon,
  ExpenseIconActive,
  ReportIcon,
  ReportIconActive,
  RoleIcon,
  RoleIconActive,
  SAMVideoIcon,
  SAMVideoIconActive,
  SettingIcon,
  SettingIconActive,
} from "../../assets/ExportImageIcon";
import { useSelector } from "react-redux";

// Check if admin has ANY permission true for a module
const hasAnyPermission = (permissions, moduleName) => {
  const mod = permissions.find((p) => p.module === moduleName);
  if (!mod) return false;
  return mod.view || mod.create || mod.edit || mod.approve;
};

const AdminSidebar = ({ collapsed }) => {
  const [isHover, setIsHover] = useState(false);
  const role = useSelector((state) => state.auth.role);
  const permissions = useSelector((state) => state.auth.permissions);

  // user_type 0 = Super Admin (no permission check), 1 = Admin (permission check)
  const isSuperAdmin = role === 0;
  const canShow = (moduleName) => isSuperAdmin || hasAnyPermission(permissions, moduleName);

  const isExpanded = !collapsed || isHover;

  return (
    <div
      className={`sidebar ${collapsed ? "collapsed" : ""} ${isHover ? "hover-open" : ""}`}
      onMouseEnter={() => collapsed && setIsHover(true)}
      onMouseLeave={() => { if (collapsed) setIsHover(false); }}
    >
      {/* LOGO */}
      <div className="logo">
        <img src={Logo} alt="Logo" className="logo-img" />
      </div>

      <ul className="menu">
        {/* DASHBOARD */}
        {isExpanded && <li className="menu-title">DASHBOARD</li>}
        <li className="menu-item">
          <NavLink to="/admin-dashboard" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
            {({ isActive }) => (
              <>
                <img src={isActive ? DashboardIconActive : DashboardIcon} className="menu-icon-img" alt="" />
                {isExpanded && <span className="menu-text">Dashboard</span>}
              </>
            )}
          </NavLink>
        </li>

        {/* PLATFORM */}
        {isExpanded && <li className="menu-title">PLATFORM</li>}

        {canShow("Organizations") && (
          <li className="menu-item">
            <NavLink to="/organizations" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
              {({ isActive }) => (
                <>
                  <img src={isActive ? OrganizationIconActive : OrganizationIcon} className="menu-icon-img" alt="" />
                  {isExpanded && <span className="menu-text">Organizations</span>}
                </>
              )}
            </NavLink>
          </li>
        )}

        {canShow("Customers") && (
          <li className="menu-item">
            <NavLink to="/customers" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
              {({ isActive }) => (
                <>
                  <img src={isActive ? CustomerIconActive : CustomerIcon} className="menu-icon-img" alt="" />
                  {isExpanded && <span className="menu-text">Customers</span>}
                </>
              )}
            </NavLink>
          </li>
        )}

        {canShow("Program Managers") && (
          <li className="menu-item">
            <NavLink to="/program-managers" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
              {({ isActive }) => (
                <>
                  <img src={isActive ? ProgramManagerIconActive : ProgramManagerIcon} className="menu-icon-img" alt="" />
                  {isExpanded && <span className="menu-text">Program Managers</span>}
                </>
              )}
            </NavLink>
          </li>
        )}

        {canShow("Vendors") && (
          <li className="menu-item">
            <NavLink to="/vendors" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
              {({ isActive }) => (
                <>
                  <img src={isActive ? VendorIconActive : VendorIcon} className="menu-icon-img" alt="" />
                  {isExpanded && <span className="menu-text">Vendors</span>}
                </>
              )}
            </NavLink>
          </li>
        )}

        {canShow("Services") && (
          <li className="menu-item">
            <NavLink to="/services" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
              {({ isActive }) => (
                <>
                  <img src={isActive ? ServiceIconActive : ServiceIcon} className="menu-icon-img" alt="" />
                  {isExpanded && <span className="menu-text">Services</span>}
                </>
              )}
            </NavLink>
          </li>
        )}

        {/* BUSINESS */}
        {isExpanded && <li className="menu-title">BUSINESS</li>}

        {canShow("Business Users") && (
          <li className="menu-item">
            <NavLink to="/business-users" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
              {({ isActive }) => (
                <>
                  <img src={isActive ? BusinessUserIconActive : BusinessUserIcon} className="menu-icon-img" alt="" />
                  {isExpanded && <span className="menu-text">Business Users</span>}
                </>
              )}
            </NavLink>
          </li>
        )}

        {/* <li className="menu-item">
          <NavLink to="/subscriptions" className="menu-link">
            <img src={transactionIcon} className="menu-icon-img" alt="" />
            {isExpanded && <span className="menu-text">Subscriptions</span>}
          </NavLink>
        </li> */}

        {canShow("Expense Management") && (
          <li className="menu-item">
            <NavLink to="/expense-management" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
              {({ isActive }) => (
                <>
                  <img src={isActive ? ExpenseIconActive : ExpenseIcon} className="menu-icon-img" alt="" />
                  {isExpanded && <span className="menu-text">Expense Management</span>}
                </>
              )}
            </NavLink>
          </li>
        )}

        {canShow("Reports & Analytics") && (
          <li className="menu-item">
            <NavLink to="/analytics-reports" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
              {({ isActive }) => (
                <>
                  <img src={isActive ? ReportIconActive : ReportIcon} className="menu-icon-img" alt="" />
                  {isExpanded && <span className="menu-text">Reports & Analytics</span>}
                </>
              )}
            </NavLink>
          </li>
        )}

        {/* ADMINISTRATION */}
        {isExpanded && <li className="menu-title">ADMINISTRATION</li>}

        {/* {canShow("AI Buddy Management") && (
          <li className="menu-item">
            <NavLink to="/housing" className="menu-link">
              <img src={transactionIcon} className="menu-icon-img" alt="" />
              {isExpanded && <span className="menu-text">AI Buddy Management</span>}
            </NavLink>
          </li>
        )} */}

        {/* <li className="menu-item">
          <NavLink to="/cms" className="menu-link">
            <img src={transactionIcon} className="menu-icon-img" alt="" />
            {isExpanded && (
              <span className="menu-text">CMS Management</span>
            )}
          </NavLink>
        </li> */}

        {canShow("Roles & Permissions") && (
          <li className="menu-item">
            <NavLink to="/role-permissions" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
              {({ isActive }) => (
                <>
                  <img src={isActive ? RoleIconActive : RoleIcon} className="menu-icon-img" alt="" />
                  {isExpanded && <span className="menu-text">Roles & Permissions</span>}
                </>
              )}
            </NavLink>
          </li>
        )}

        {canShow("SAM Videos") && (
          <li className="menu-item">
            <NavLink to="/sam-videos" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
              {({ isActive }) => (
                <>
                  <img src={isActive ? SAMVideoIconActive : SAMVideoIcon} className="menu-icon-img" alt="" />
                  {isExpanded && <span className="menu-text">SAM Video</span>}
                </>
              )}
            </NavLink>
          </li>
        )}

        {canShow("Settings") && (
          <li className="menu-item">
            <NavLink to="/settings" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
              {({ isActive }) => (
                <>
                  <img src={isActive ? SettingIconActive : SettingIcon} className="menu-icon-img" alt="" />
                  {isExpanded && <span className="menu-text">Settings</span>}
                </>
              )}
            </NavLink>
          </li>
        )}
      </ul>
    </div>
  );
};

export default AdminSidebar;